import Vue from "vue";
import Router from "vue-router";
import api from "@/api";
Vue.use(Router);
const router = new Router({
  routes: [
    {
      path: "/home",
      component: () => import("@/layout/Home"),
      children: []
    },
    {
      path: "/",
      name: "login",
      component: () => import("@/layout/Login")
    }
  ]
});

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  if (to.name == "login") {
    next();
  } else {
    var user = JSON.parse(window.sessionStorage.getItem("user"));
    user = 1;
    var menuList = JSON.parse(window.sessionStorage.getItem("menuList"));
    var oldRoutes = router.options.routes[0].children;
    if (user != null && (menuList == null || oldRoutes.length == 0)) {
      getMenu();
    } else {
      next();
    }
  }
});

//得到路由
function getMenu() {
  api.menuAPI
    .getMenuList()
    .then(response => {
      if (response.status == 200) {
        console.log("//得到路由", response);
        if (response.data == null || response.data.length == 0) {
          Vue.prototype.$message.error("该角色无权限，请刷新重试");
          return;
        }
        var menuList = [];
        for (let index in response.data) {
          var menuItem = {
            path:
              response.data[index].path != null
                ? response.data[index].path
                : "/",
            name: response.data[index].title,
            title: response.data[index].title,
            component: null
          };

          try {
            menuItem["meta"] = {
              parentTitle:
                response.data[index].parent != null
                  ? response.data[index].parent.title
                  : ""
            };
            let component = response.data[index].component;
            menuItem["component"] = () => import(`@/${component}`);
          } catch (e) {
            console.log(e);
          }
          menuList.push(menuItem);
        }
        router.options.routes[0].children = menuList;

        let firstRoute = [];
        firstRoute.push(router.options.routes[0]);
        router.addRoutes(firstRoute);
        window.sessionStorage.setItem(
          "menuList",
          JSON.stringify(response.data)
        );
        router.push(menuList[0].path);
      }
    })
    .catch(error => {
      console.log(error);
    });
}

export default router;
